import ListItem, {
  DefaultAvatarSize,
  ListItemData,
  ListItemProps
} from "@jd/focus-desktop-comps/lib/es/ListItem";
import React, { useMemo } from "react";
import { SearchType } from "@/services/SearchService";
import { SearchGlobalContext } from "@/components/Modals/SearchGlobalModal/utils";
import { ContactsTag, GroupTag } from "@/components/Tags";
import Rete from "@/components/ThirdApp/components/Rate";
import { Group } from "@/types/chat";
import { Avatar } from "@/baseComponents/Avatar";
import { RecommendedType } from "@/services/AppStore";
import GlobalContext from "@/context/GlobalContext";
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import { changeEgovUrl } from "@/utils/tools";
import { Tooltip } from "antd";
import { isEqualEmployee } from "@/utils/chat/message";
import { connect } from "dva";
import ChatState from "@/types/chat/State";
import SearchJoyItem from "./SearchJoyItem";

type IProps = Readonly<ChatState>;

const SearchListItem = (
  props: {
    data: ListItemData;
    onClick?: (data: ListItemData) => void;
    extra?: React.ReactNode;
    t: any;
  } & ListItemProps &
    IProps
) => {
  const { onGetAvatarURL, authData, activeKey } = React.useContext(SearchGlobalContext);
  const { authInfo } = React.useContext(GlobalContext);
  const { data, onClick, extra, t, currentEmployee, ...rest } = props;
  const { avatar, searchKey } = data;
  const origin = data.origin;
  let itemTag: any = null;
  let isGroup = false;
  if (searchKey === SearchType.Contacts || searchKey === SearchType.Group) {
    if (origin.userId === data.id) {
      // 联系人
      const userI = { teamId: origin.teamId, app: origin.app };
      const userII = {
        teamId: authData?.teamUserInfo?.teamId || authInfo?.teamUserInfo?.teamId,
        app: authData?.ddAppId || authInfo?.ddAppId
      };
      itemTag = <ContactsTag userI={userI} userII={userII} />;
    } else if ((origin.gid || origin.groupId) === data.id) {
      // 群组
      const group: Group = { ...origin, ...origin.ext };
      itemTag = <GroupTag group={group} />;
      isGroup = true;
      data.isGroup = true;      
    }
  } else if (searchKey === SearchType.App) {
    // 推荐
    itemTag =
      data.origin.ext.recommended === RecommendedType.RecommendedYes ? <Rete value={0} /> : null;
  }

  let setAvatar: any = null;
  if (onGetAvatarURL && typeof avatar === "string") {
    setAvatar = onGetAvatarURL(avatar, DefaultAvatarSize, DefaultAvatarSize);
  } else if (typeof avatar === "string") {
    setAvatar = (
      <Avatar
        tag={data.origin?.accountType === 1 ? "公共账号" : ""}
        src={changeEgovUrl(getHeadImgThumbUrl(avatar, 150, 150) || "")}
        name={data?.displayName || ""}
        type={isGroup ? "group" : "user"}
      />
    );
  } else if (React.isValidElement(avatar)) {
    setAvatar = avatar;
  } else {
    setAvatar = (
      <Avatar
        tag={data.origin?.accountType === 1 ? "公共账号" : ""}
        name={data?.displayName || ""}
        type={isGroup ? "group" : "user"}
      />
    );
  }
  const listItemNode = useMemo(() => {
    if (data.searchKey === SearchType.JoySpace) {
      return (
        <SearchJoyItem
          t={t}
          data={data}
          onClick={() => {
            if (onClick) {
              onClick(data);
            }
          }}
        />
      );
    }
    return (
      <ListItem
        style={{
          padding: "10.8px 16px"
        }}
        data={{
          ...data,
          avatar: setAvatar
        }}
        onClick={() => {
          if (onClick) {
            onClick(data);
          }
        }}
        itemShowRemark
        extra={extra}
        tag={itemTag}
        {...rest}
      />
    );
  }, [data, extra, itemTag, onClick, rest, setAvatar, t]);

  const listItemTip = useMemo(() => {
    if (data?.origin && isEqualEmployee(currentEmployee, data.origin)) {
      return <div className="search-tip">提示：您可以将与自己的会话作为文件传输助手使用</div>;
    } else {
      return null;
    }
  }, [data, currentEmployee]);

  const searchNode = useMemo(() => {
    if (data.realDesc && data.searchKey === SearchType.Contacts) {
      return (
        <Tooltip placement="top" title={<div className="Tooltip-title">{data.realDesc}</div>}>
          <div className="search-item-wrap">
            {listItemNode}
            {listItemTip}
          </div>
        </Tooltip>
      );
    } else {
      return <div className="search-item-wrap">{listItemNode}</div>;
    }
  }, [data, listItemNode, listItemTip]);
  return searchNode;
};

function mapStateToProps({ chat }: any) {
  const { currentEmployee } = chat as ChatState;
  return { currentEmployee };
}

export default connect(mapStateToProps)(SearchListItem);
